import axios from "axios";
import {baseUrlOffer, xApiKeyOffer} from "../../config/api/apiConfig";

const companyCode = "amarta";

class OfferApiServices {
    private axios = axios.create({
        baseURL: baseUrlOffer,
    });

    public setToken(token: string) {
        this.axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    }

    public async getDetailOffer(params?: any) {
        const finalCompanyCOde = params?.companyCode ? params?.companyCode?.toLowerCase() : companyCode;

        let siteUrl = `/offer/${finalCompanyCOde}/${params.offerCode}`;
        const queries = {
            ...(params?.getDetailOrder && {
                get_detail_order: "true",
            }),
            ...(params?.getDetailCashback && {
                get_detail_cashback: "true",
            }),
            ...(params?.getPayment && {
                get_payment: "true",
            }),
        };

        try {
            return await this.axios.get<any>(`${siteUrl}`, {
                headers: {
                    "X-Api-Key": xApiKeyOffer,
                },
                params: {
                    ...queries,
                },
            });
        } catch (e: any) {
            throw new Error(e?.response?.data?.error?.message);
        }
    }

    public async getOffer(params?: any) {
        const queries = {
            ...(params?.startDate && {
                start_date: params.startDate,
            }),
            ...(params?.endDate && {
                end_date: params.endDate,
            }),
            ...(params?.area && {
                area: params.area.toLowerCase(),
            }),
            ...(params?.areaStock && {
                area_stock: params.areaStock.toLowerCase(),
            }),
            ...(params?.status && {
                status: params.status.toLowerCase(),
            }),
            ...(params?.purchaseMethod && {
                purchase_method: params.purchaseMethod.toLowerCase(),
            }),
            ...(params?.additionalData && {
                additional_data: params.additionalData.toLowerCase(),
            }),
            ...(params?.searchType && {
                search_type: params.searchType,
            }),
            ...(params?.searchOfferCode && {
                offer_code: params.searchOfferCode,
            }),
            ...(params?.searchPoCode && {
                po_code: params.searchPoCode,
            }),
        };

        const finalCompanyCOde = params?.companyCode ? params?.companyCode?.toLowerCase() : companyCode;

        try {
            return await this.axios.get<any>(`/offer/${finalCompanyCOde}`, {
                headers: {
                    "X-Api-Key": xApiKeyOffer,
                },
                params: {
                    ...queries,
                },
            });
        } catch (e: any) {
            throw new Error(e?.response?.data?.error?.message);
        }
    }

    public async getPaymentHistoryOffer(params?: any) {
        try {
            return await this.axios.get<any>(`/bill/fin/${companyCode}/${params.offerCode}`, {
                headers: {
                    "X-Api-Key": xApiKeyOffer,
                },
            });
        } catch (e: any) {
            throw new Error(e.response.data.error.message);
        }
    }

    public async createOrder(inputData?: any) {
        try {
            return await this.axios.post<any>("/order/otodis/create-order", inputData, {
                headers: {
                    "Content-Type": "application/json",
                    "X-Api-Key": xApiKeyOffer,
                },
            });
        } catch (e: any) {
            throw new Error(e.response.data.error.message);
        }
    }

    public async cancelOffer(inputData?: any) {
        try {
            return await this.axios.put<any>("/cancel-offer", inputData, {
                headers: {
                    "Content-Type": "application/json",
                    "X-Api-Key": xApiKeyOffer,
                },
            });
        } catch (e: any) {
            throw new Error(e.response.data.error.message);
        }
    }

    public async removeQcOffer(inputData?: any) {
        try {
            return await this.axios.put<any>("/update-offer", inputData, {
                headers: {
                    "Content-Type": "application/json",
                    "X-Api-Key": xApiKeyOffer,
                },
            });
        } catch (e: any) {
            throw new Error(e.response.data.error.message);
        }
    }

    public async reactiveOffer(inputData?: any) {
        try {
            return await this.axios.put<any>("/reactive-offer", inputData, {
                headers: {
                    "Content-Type": "application/json",
                    "X-Api-Key": xApiKeyOffer,
                },
            });
        } catch (e: any) {
            throw new Error(e.response.data.error.message);
        }
    }

    public async updateOffer(inputData?: any) {
        try {
            return await this.axios.put<any>("/update-offer", inputData, {
                headers: {
                    "Content-Type": "application/json",
                    "X-Api-Key": xApiKeyOffer,
                },
            });
        } catch (e: any) {
            throw new Error(e.response.data.error.message);
        }
    }

    public async verifyPhoneNumber(inputData?: any) {
        try {
            return await this.axios.post<any>("/verify-phone-number", inputData, {
                headers: {
                    "Content-Type": "application/json",
                    "X-Api-Key": xApiKeyOffer,
                },
            });
        } catch (e: any) {
            throw new Error(e.response.data.error.message);
        }
    }

    public async getDataCashbackAgent(params?: any) {
        const queries = {
            ...(params?.dealerCode && {
                dealer_code: params.dealerCode,
            }),
            ...(params?.cityCode && {
                city_code: params.cityCode,
            }),
        };
        try {
            return await this.axios.get<any>(`/cashback-agent/${companyCode}/${params?.offerCode}`, {
                headers: {
                    "Content-Type": "application/json",
                    "X-Api-Key": xApiKeyOffer,
                },
                params: {
                    ...queries,
                },
            });
        } catch (e: any) {
            throw new Error(e.response.data.message);
        }
    }

    public async getByDateDataCashbackAgent(params?: any) {
        const queries = {
            ...(params?.startDate && {
                start_date: params.startDate,
            }),
            ...(params?.endDate && {
                end_date: params.endDate,
            }),
            ...(params?.active && {
                active: params.active,
            }),
            ...(params?.status && {
                status: params.status,
            }),
            ...(params?.filterTimeRange && {
                time_range: params.filterTimeRange,
            }),
            ...(params?.showPaidColumn && {
                check_payment: params.showPaidColumn,
            }),
        };
        try {
            return await this.axios.get<any>(`/cashback-agent/${companyCode}`, {
                headers: {
                    "Content-Type": "application/json",
                    "X-Api-Key": xApiKeyOffer,
                },
                params: {
                    ...queries,
                },
            });
        } catch (e: any) {
            throw new Error(e.response.data.message);
        }
    }

    public async getLogAutomaticClosing(params?: any) {
        const axioLogUrl = axios.create({
            baseURL: `https://otodis-bucket.s3.ap-southeast-1.amazonaws.com`,
        });

        try {
            return await axioLogUrl.get<any>(`/log-closing/${params?.companyCode?.toUpperCase()}/${params.yearMonth}/${params.yearMonthDate}.json`, {
                headers: {
                    // "Content-Type": "application/json",
                },
                params: {},
            });
        } catch (e: any) {
            throw new Error(e);
        }
    }

    public async getPrebookingByDate(params?: any) {
        const companyPrebooking = params?.companyCode;
        const queries = {
            ...(params?.startDate && {
                start_date: params.startDate,
            }),
            ...(params?.endDate && {
                end_date: params.endDate,
            }),
        };
        try {
            return await this.axios.get<any>(`/prebooking/${companyPrebooking}`, {
                headers: {
                    "Content-Type": "application/json",
                    "X-Api-Key": xApiKeyOffer,
                },
                params: {
                    ...queries,
                },
            });
        } catch (e: any) {
            console.log();
            throw new Error(e.response?.data?.error?.message);
        }
    }

    public async getPrebookingDetail(params?: any) {

        console.log(params);

        try {
            return await this.axios.get<any>(`/prebooking/${params?.companyCode}/${params?.prebookingCode}`, {
                headers: {
                    "Content-Type": "application/json",
                    "X-Api-Key": xApiKeyOffer,
                },
            });
        } catch (e: any) {
            console.log();
            throw new Error(e.response?.data?.error?.message);
        }
    }

    public async getDashboard(params?: any) {
        const queries = {
            ...(params?.startDate && {
                start_date: params.startDate,
            }),
            ...(params?.endDate && {
                end_date: params.endDate,
            }),
            ...(params?.area && {
                area: params.area.toLowerCase(),
            })
        };

        const finalCompanyCOde = params?.companyCode ? params?.companyCode?.toLowerCase() : companyCode;

        try {
            return await this.axios.get<any>(`/offer/${finalCompanyCOde}/dashboard`, {
                headers: {
                    "X-Api-Key": xApiKeyOffer,
                },
                params: {
                    ...queries,
                },
            });
        } catch (e: any) {
            throw new Error(e?.response?.data?.error?.message);
        }
    }
}

export const offerApiServices = new OfferApiServices();
